// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/account_management/api/topups/card_payments/firstparty/v4/create_flow_payment_session.proto

/* oxlint-disable */
import { ApiCurrencyAmount } from "../../../../../../common/payment";

/** Request to create a Checkout.com Flow payment session for top-up. */
export interface ApiCreateFlowPaymentSessionRequest {
  /** Amount to top up. Typically 0 for Flow sessions where the amount is entered in the payment widget. */
  readonly amount:
    | ApiCurrencyAmount
    | null;
  /** URL to redirect the user after a successful top-up. */
  readonly successUrl: string;
  /** URL to redirect the user after a failed top-up. */
  readonly failureUrl: string;
  /** Source context of the top-up (e.g. "add_money"). */
  readonly source: string;
}

/** Response for a Checkout.com Flow payment session request. */
export interface ApiCreateFlowPaymentSessionResponse {
  /** Unique identifier of the payment session. */
  readonly id: string;
  /** Token used to mount Checkout.com Flow components. */
  readonly paymentSessionToken: string;
  /** Secret for the payment session. */
  readonly paymentSessionSecret: string;
  /** Hypermedia links for the payment session resource. */
  readonly links: ApiCreateFlowPaymentSessionResponseLinks | null;
}

/** Hyperlink reference. */
export interface ApiCreateFlowPaymentSessionResponseLink {
  /** URL of the link. */
  readonly href: string;
}

/** Hypermedia links for the payment session. */
export interface ApiCreateFlowPaymentSessionResponseLinks {
  /** Link to the payment session resource. */
  readonly self: ApiCreateFlowPaymentSessionResponseLink | null;
}

export const ApiCreateFlowPaymentSessionRequest: MessageFns<ApiCreateFlowPaymentSessionRequest> = {
  fromJSON(object: any): ApiCreateFlowPaymentSessionRequest {
    return {
      amount: isSet(object.amount) ? ApiCurrencyAmount.fromJSON(object.amount) : null,
      successUrl: isSet(object.success_url) ? globalThis.String(object.success_url) : "",
      failureUrl: isSet(object.failure_url) ? globalThis.String(object.failure_url) : "",
      source: isSet(object.source) ? globalThis.String(object.source) : "",
    };
  },

  toJSON(message: ApiCreateFlowPaymentSessionRequest): unknown {
    const obj: any = {};
    if (message.amount !== undefined && message.amount !== null) {
      obj.amount = ApiCurrencyAmount.toJSON(message.amount);
    }
    if (message.successUrl !== undefined && message.successUrl !== null) {
      obj.success_url = message.successUrl;
    }
    if (message.failureUrl !== undefined && message.failureUrl !== null) {
      obj.failure_url = message.failureUrl;
    }
    if (message.source !== undefined && message.source !== null) {
      obj.source = message.source;
    }
    return obj;
  },
};

export const ApiCreateFlowPaymentSessionResponse: MessageFns<ApiCreateFlowPaymentSessionResponse> = {
  fromJSON(object: any): ApiCreateFlowPaymentSessionResponse {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      paymentSessionToken: isSet(object.payment_session_token) ? globalThis.String(object.payment_session_token) : "",
      paymentSessionSecret: isSet(object.payment_session_secret)
        ? globalThis.String(object.payment_session_secret)
        : "",
      links: isSet(object.links) ? ApiCreateFlowPaymentSessionResponseLinks.fromJSON(object.links) : null,
    };
  },

  toJSON(message: ApiCreateFlowPaymentSessionResponse): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.paymentSessionToken !== undefined && message.paymentSessionToken !== null) {
      obj.payment_session_token = message.paymentSessionToken;
    }
    if (message.paymentSessionSecret !== undefined && message.paymentSessionSecret !== null) {
      obj.payment_session_secret = message.paymentSessionSecret;
    }
    if (message.links !== undefined && message.links !== null) {
      obj.links = ApiCreateFlowPaymentSessionResponseLinks.toJSON(message.links);
    }
    return obj;
  },
};

export const ApiCreateFlowPaymentSessionResponseLink: MessageFns<ApiCreateFlowPaymentSessionResponseLink> = {
  fromJSON(object: any): ApiCreateFlowPaymentSessionResponseLink {
    return { href: isSet(object.href) ? globalThis.String(object.href) : "" };
  },

  toJSON(message: ApiCreateFlowPaymentSessionResponseLink): unknown {
    const obj: any = {};
    if (message.href !== undefined && message.href !== null) {
      obj.href = message.href;
    }
    return obj;
  },
};

export const ApiCreateFlowPaymentSessionResponseLinks: MessageFns<ApiCreateFlowPaymentSessionResponseLinks> = {
  fromJSON(object: any): ApiCreateFlowPaymentSessionResponseLinks {
    return { self: isSet(object.self) ? ApiCreateFlowPaymentSessionResponseLink.fromJSON(object.self) : null };
  },

  toJSON(message: ApiCreateFlowPaymentSessionResponseLinks): unknown {
    const obj: any = {};
    if (message.self !== undefined && message.self !== null) {
      obj.self = ApiCreateFlowPaymentSessionResponseLink.toJSON(message.self);
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
